const comments = [
  {
    name: '追剧达人小李',
    text: '用了小草影院半年多了，更新速度确实快，基本上卫视播完当晚就能看。画质也很清晰，1080P看着很舒服。关键是没广告不用注册，追剧体验真的太好了！',
    time: '3天前',
    from: '来自：广东',
  },
  {
    name: '影视爱好者阿琳',
    text: '之前试过很多追剧网站，要么卡顿要么画质差。小草影院的多线CDN确实名不虚传，加载速度很快。剧集也很全，国产剧、日韩剧都有，现在已经是我的追剧首选了。',
    time: '5天前',
    from: '来自：上海',
  },
  {
    name: '夜班追剧族老张',
    text: '上夜班的时候就靠小草影院消磨时间了。APP的夜间模式对眼睛很友好，倍速播放也很实用。最近剧集更新也很快，狂飙全集上线当天就能看了，太给力了！',
    time: '1周前',
    from: '来自：北京',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-600 text-xs font-medium mb-3">
            <i className="ri-chat-quote-line"></i>
            真实评价
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 mt-2">来自追剧用户的真实心声</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {comments.map((c) => (
            <div
              key={c.name}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60"
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm text-primary-400"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{c.text}</p>
              <div className="flex items-center justify-between border-t border-background-200/60 pt-3">
                <div>
                  <p className="text-sm font-bold text-foreground-900">{c.name}</p>
                  <p className="text-xs text-foreground-400">{c.from}</p>
                </div>
                <span className="text-xs text-foreground-400">{c.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}